import api from '@/api/openApi'

const state = {

}

const actions = {
  createExportOpenApiMetaDataTask (context, taskInfo) {
    return api.createExportOpenApiMetaDataTask(taskInfo)
  },
  getExportOpenApiMetaDataTask (context, params) {
    return api.getExportOpenApiMetaDataTask(params)
  },
  getOpenApiAppList (context, params) {
    return api.getOpenApiAppList(params)
  },
  createOpenApiApp (context, appInfo) {
    return api.createOpenApiApp(appInfo)
  },
  updateOpenApiApp (context, { openApiAppId, appInfo }) {
    return api.updateOpenApiApp(openApiAppId, appInfo)
  },
  getOpenApiList (context, params) {
    return api.getOpenApiList(params)
  },
  getOpenApiConfig (context, { openApiId, params }) {
    return api.getOpenApiConfig(openApiId, params)
  },
  getOpenApiConfigList (context, params) {
    return api.getOpenApiConfigList(params)
  },
  getOpenApiConfigById (context, { openApiId, configId }) {
    return api.getOpenApiConfigById(openApiId, configId)
  },
  saveOpenApiConfig (context, { openApiId, config }) {
    return api.saveOpenApiConfig(openApiId, config)
  },
  updateOpenApiConfig (context, { openApiId, configId, config }) {
    return api.updateOpenApiConfig(openApiId, configId, config)
  },
  updateOpenApiConfigStatus (context, { openApiId, configId, updateInfo }) {
    return api.updateOpenApiConfigStatus(openApiId, configId, updateInfo)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
